import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button } from '@chakra-ui/react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory, Link } from 'react-router-dom'
import hash from 'object-hash'
import { useTranslation } from 'react-i18next'

import SpinnerLoading from 'components/Loading/SpinnerLoading'
import * as actions from '../../../../redux/actions'
import EachVariableBox from '../../../../components/Variables/Making/EachVariableBox'
import VariableTemplate from '../../../../template/VariableTemplate.json'

export default function ManagementVariable() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const params = useParams()
  const allStations = useSelector((state) => state.station)
  const dispatch = useDispatch()
  const history = useHistory()
  const [currentStation, setCurrentStation] = useState()

  useEffect(() => {
    dispatch(actions.stationAll()).then(() => {})
    return () => {}
  }, [params])

  useEffect(() => {
    if (allStations) {
      const tempcurrentStatus = _.find(
        allStations.arr,
        (station) => station?._id === params?.id
      )
      setCurrentStation(tempcurrentStatus)
    }
    setIsLoading(true)
    return () => {}
  }, [params, allStations])

  const handleCreateVariables = () => {
    setIsLoading(false)
    const tempVariableTemplate = VariableTemplate
    tempVariableTemplate.id = hash({
      date: new Date(),
      randomNum: Math.random(),
    })

    dispatch(
      actions.stationAddVariablePut(currentStation._id, tempVariableTemplate)
    )
      .then(() => {
        dispatch(actions.stationAll()).then(() => {})
      })
      .catch((err) => {
        alert('Error ' + err?.message)
        dispatch(actions.stationAll())
      })
  }

  if (currentStation && isLoading) {
    return (
      <div>
        <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
          <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex-grow flex-1">
                <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
                  {t('setting.systemManagement')}
                </h6>
                <h2 className="text-gray-800 text-2xl font-bold font-sans">
                  {t('setting.stationVariableManagement')} {currentStation.name}
                </h2>
              </div>
            </div>
          </div>
          <div className="flex justify-start gap-1 p-4">
            <Button
              colorScheme="blue"
              variant="solid"
              size="sm"
              onClick={() => handleCreateVariables()}
            >
              {t('utility.add')}
            </Button>
          </div>
          <div className="p-4 w-full">
            {_.map(currentStation?.variables, (variable, index) => (
              <div>
                <EachVariableBox
                  key={index}
                  index={index}
                  variableData={variable}
                  stationData={currentStation}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  } else {
    return <SpinnerLoading />
  }
}
